export default __webpack_public_path__ + "static/media/sms.ae45c9e8.svg";